import { colorBrandPrimary } from 'src/global.style'
import styled from 'styled-components'
import { media } from '../../../../../layouts/utils'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	filter: ${({ blur }) => (blur ? 'blur(2px)' : '')};
	.botoesCupons {
		display: flex;
		gap: 2rem;

		${media.phone`
			flex-direction: column !important;
			gap: 1rem;
			width: 130px;
 		`}
	}
`
export const Terms = styled.div`
	display: flex;
	gap: 0.875rem;
	color: ${colorBrandPrimary.marine};
	font-size: 1rem;
	margin-top: 1rem;

	b {
		text-decoration: underline;
		user-select: none;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
		&:hover {
			filter: brightness(1.2);
		}
	}

	label {
		color: ${({ isChecked }) => isChecked ? '#230C87' : '#979797'};
		font-family: "Work Sans";
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;

		b {
			font-weight: 600;
			text-decoration-line: underline;
		}
	}

	${media.phone`
		font-size: 0.875rem;
		margin: 0.5rem;
		gap: 1.85rem;
		align-items: baseline;

		.container.calibri {
			width: 30px;
		}
 	`}
`
export const Link = styled.a`
	text-decoration: none;
	${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
`
export const ModalHeader = styled.div`
	display: flex;
	align-content: center;
	justify-content: flex-end;
	width: 100%;
	height: 40px;
`
export const CloseButton = styled.img`
	width: 1.5rem;
	height: 1.5rem;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	&:hover {
		filter: brightness(2);
	}
`
export const Line = styled.p`
	margin-bottom: 0.75rem;
	font-weight: 400;

	.bold {
		font-weight: bold;
	}
	.italic {
		font-style: italic;
	}
	.underline {
		text-decoration: underline;
	}
	.strike {
		text-decoration: line-through;
	}
`
export const TextBlock = styled.span`
	&.underline {
		text-decoration: underline;
	}
	&.bold {
		font-weight: bold;
	}
	&.italic {
		font-style: italic;
	}
`
